<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择车间"
      width="900px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        :columns-btn-show="false"
        module="basic"
        url="workshops">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="车间编号：">
            <el-input v-model.trim="filter.workshopNo" placeholder="请输入车间编号" clearable/>
          </vm-search>
          <vm-search label="车间名称：">
            <el-input v-model.trim="filter.workshopName" placeholder="请输入车间名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="workshopNo" align="center" label="车间编号" width="120"/>
      <el-table-column prop="workshopName" align="left" label="车间名称"/>
      <el-table-column label="操作" align="center" width="80px" prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "WorkShopSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {},
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>